import { render } from "./TheChooser.vue?vue&type=template&id=d8077926&scoped=true"
import script from "./TheChooser.vue?vue&type=script&lang=js"
export * from "./TheChooser.vue?vue&type=script&lang=js"

import "./TheChooser.vue?vue&type=style&index=0&id=d8077926&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/1mal1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8077926"]])

export default __exports__